import type { AssignedResourcesTranslationMessages } from './assignedResourcesTranslationMessages';

export const assignedResourcesLanguageItalian: AssignedResourcesTranslationMessages = {
  assigned_lcrs: {
    name: 'Least Cost Routing',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: 'Etichette',
    },
  },
  assigned_sip_profiles: {
    name: 'Profili SIP',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: 'Etichette',
    },
  },
  assigned_carriers: {
    name: 'Trunk SIP',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: 'Etichette',
    },
  },
  assigned_inbound_e164s: {
    name: 'Inbound E164',
    fields: {
      id: 'ID',
      e164_match: 'E164 Match',
      description: 'Descrizione',
      labels: 'Etichette',
      callflow: 'Dialplan',
    },
  },
};
